import axiosInstance from './AxiosInstance';
const divisionUrl = "api/division"


export function getDivisionListApi(page, page_size, filters={}) {
    const params = new URLSearchParams({
        page,
        page_size,
        ...filters
    });
    return axiosInstance.get(`${divisionUrl}?${params.toString()}`);
}

export function getQuizApi(id) {
    return axiosInstance.get(`${divisionUrl}/${id}`);
}

export function createDivisionApi(data) {
    return axiosInstance.post(divisionUrl, data);
}

export function updateDivisionApi(id,data) {
    return axiosInstance.put(`${divisionUrl}/${id}`, data);
}

export function deleteDivisionApi(id) {
    return axiosInstance.delete(`${divisionUrl}/${id}`);
}

